import React from "react";

function Todo() {
  return (
    <>
      <h1>To-do</h1>
      <ul>
        <li>universal styling</li>
        <li>separate header</li>
        <li>create footer</li>
        <li>
          implement categories: categories table, the song table, and
          categories-song mapping table that holds the mapping of category_id
          and song_id. each category on a new page
        </li>
        <li>add pancit kantas</li>
        <li>info/credits page</li>
        <li>make logo clickable to go to home/search page</li>
        <li>organize css</li>
        <li>organize directory?</li>
        <li>error page</li>
        <li>make entries in table of contents actually look nice</li>
        <li>admin page: create form</li>
        <li>admin page: link form to database</li>
        <li>admin page: create admin account feature</li>
        <li>tailwind</li>
        <li>admin page: create log in page</li>
        <li>sort song list by artist, title, etc</li>
        <li>refactor directory</li>
        <li>
          search should 100% be a separate component for searching within
          categories later!!
        </li>
      </ul>
    </>
  );
}

export default Todo;
